// import constants
import {
  CARE_RECEIVERS_SESSION_STORAGE_KEYS,
  TabType
} from 'components/roster-portal/care-receivers/types';

// import types
import type { CareReceiverHandover } from 'components/roster-portal/care-receivers/types';

/**
 * Hands the care receiver over to their own page through session storage and navigates to the
 * prescriptions tab, so a planner can see the prescription behind a deficit straight away.
 *
 * The tab travels in the hash — the Dojo host strips `&` params before matching the route — while the
 * care receiver travels in session storage: that page keeps its selection in state, and a label
 * containing a comma has no business in an unencoded hash param.
 */
export const navigateToCareReceiverPrescriptions = (
  careReceiverId: string,
  name: string
) => {
  const handover: CareReceiverHandover = { careReceiverId, name };

  window.sessionStorage.setItem(
    CARE_RECEIVERS_SESSION_STORAGE_KEYS.SELECTED_CARE_RECEIVER,
    JSON.stringify(handover)
  );

  window.location.href = `#roster,careReceivers&page=${TabType.PRESCRIPTIONS}`;
};
